import { Box, ButtonBase, Typography } from '@mui/material';
import { Center, StackColumn } from '@ocodelib/mui';
import {
  TutorPageGuideDialog,
  type TutorPageGuideDialogProps,
} from '@repo-ui/dialogs/TutorPageGuideDialog';
import { useState } from 'react';
import { AspectRatio } from 'react-aspect-ratio';
import { toast } from 'react-toastify';
import { TUT_LEVEL_COLORS } from './tut-constants';
import type { Tutor } from './tut-lectures';
import TutorLevelMark from './TutorLevelMark';

interface Props {
  tutor: Tutor;
}
type DialogId = 'TutorPageGuideDialog';

export default function TutorCard(props: Props) {
  const { tutor } = props;
  const [dialogId, setDialogId] = useState<DialogId>();
  const [tutorGuidDialogProps, setTutorGuidDialogProps] = useState<TutorPageGuideDialogProps>();

  const handleDialogClose = () => {
    setDialogId(undefined);
    setTutorGuidDialogProps(undefined);
  };

  const openTutorGuidDialog = (tutor: Tutor) => {
    setDialogId('TutorPageGuideDialog');
    setTutorGuidDialogProps({
      open: true,
      onClose: handleDialogClose,
    });
  };

  const handleClickArticleCard = () => {
    openTutorGuidDialog(tutor);
  };

  const handleClickDevelop = () => {
    toast.warn('준비중입니다.', { autoClose: 1500 });
  };

  const { img, title, substance, level, tutKey, url } = tutor;
  const { primary: themePrimaryColor } = TUT_LEVEL_COLORS[level];

  return (
    <>
      <ButtonBase
        component="div"
        className="TutorCard-root"
        sx={{
          display: 'block',
          bgcolor: '#fff',
          boxShadow: 1,
          maxWidth: 400,
          width: '100%',
          mx: 'auto',
          position: 'relative',
          borderTopLeftRadius: '8px',
          borderTopRightRadius: '8px',
        }}
        onClick={url ? handleClickArticleCard : handleClickDevelop}
      >
        <AspectRatio ratio="10/5.5 ">
          <Box
            component="img"
            src={img}
            alt=""
            sx={{ width: '100%', height: '100%', objectFit: 'cover', p: 1 }}
          />
        </AspectRatio>
        <Center
          sx={{
            width: '100%',
            height: 100,
            borderTop: '1px solid #ddd',
            px: 2,
          }}
        >
          <StackColumn spacing={1.5}>
            <Typography variant="h6">{title}</Typography>
            <Typography variant="body2">{substance}</Typography>
          </StackColumn>
        </Center>
        {tutKey && <TutorLevelMark level={level} levelName={tutKey} />}
      </ButtonBase>
      {dialogId === 'TutorPageGuideDialog' && tutorGuidDialogProps && (
        <TutorPageGuideDialog {...tutorGuidDialogProps} />
      )}
    </>
  );
}
